const button = "_35sbo17by6";
const stateBox = "_35ss1y9e96j";
const stateBoxContent = "_35ss5xt198";
const icon = "_35si9gakc9";

export { button, icon, stateBox, stateBoxContent };
import "./input.checkbox.style.linaria.module.css";
//# sourceMappingURL=input.checkbox.style.js.map
